export default "__VITE_ASSET__o5e148qw__"